const defaultHeaders = { "Content-Type": "application/json" };

export const getCommonJsonHeaders = (bearerToken: string) => ({
  ...defaultHeaders,
  Authorization: `Bearer ${bearerToken}`,
});
